import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PageQueryParams } from '@interfaces/params.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TableColumnsManagementComponent } from './table-columns-management/table-columns-management.component';
import { TableColumnConfig } from './table-provider';

@Component({
  selector: 'app-table-settings',
  templateUrl: './table-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableSettingsComponent implements OnChanges {
  @Input() columns?: TableColumnConfig[];
  @Input() total = 0;
  @Input() disabled = false;
  @Input() pageSizeValues? = [10, 25, 50, 100];
  @Input() queryParams: Record<string, unknown> & PageQueryParams;
  @Output() queryParamsChange = new EventEmitter<Record<string, unknown> & PageQueryParams>();
  @Output() columnsChange = new EventEmitter<TableColumnConfig[]>();
  currentPage = 1;

  constructor(private readonly modalService: NgbModal) {}

  get dataExists(): boolean {
    return !!this.total;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.queryParams) {
      this.currentPage = Number(changes.queryParams.currentValue.page) + 1;
    }
  }

  onPageChange(value: number): void {
    this.queryParams.page = value - 1;
    this.queryParamsChange.emit(this.queryParams);
  }

  onPageSizeChange(value: number): void {
    this.queryParams.pageSize = value;
    if (this.queryParams.page * value <= this.total) {
      this.queryParamsChange.emit(this.queryParams);
    }
  }

  onSortChange(sortQuery: string): void {
    this.queryParams.orderBy = sortQuery;
    this.queryParamsChange.emit(this.queryParams);
  }

  openColumnsManagement(): void {
    const modal = this.modalService.open(TableColumnsManagementComponent);
    const modalContentInstance = modal.componentInstance as TableColumnsManagementComponent;
    modalContentInstance.columns = [...this.columns];
    modal.closed.subscribe((v: TableColumnConfig[]) => {
      this.columns = v;
      this.columnsChange.emit(this.columns);
    });
  }
}
